module.exports = __webpack_public_path__ + "img/siginicon.150f6d40.svg";